<template>
  <el-col :span="24" :style="{height: height}" style="position: absolute;" class="customHotMap">
    <div id="baiduMap" style="height: 100%;width:100%;" />

    <ImageOpenDialog ref="markerDialog" :dialog-width="chartConfig.dialogWidth" :currentMarker="currentMarker"></ImageOpenDialog>
  </el-col>
</template>

<script>
  import ImageOpenDialog from './ImageOpenDialog.vue'
  require('echarts/theme/macarons') // echarts theme
  import {
    debounce
  } from '../../utils/helper.js'
  import lodash from 'lodash'
  import fwUtil from 'framework-util'
  import VideoHls from '../images/VideoHls.vue'
  import {getDataService} from '../../api/chart/chart/index.js'
  export default {
    components: {
      ImageOpenDialog
    },
    props: {
      className: {
        type: String,
        default: 'chart'
      },
      width: {
        type: Number,
        default: 24
      },
      height: {
        type: String,
        default: '100%'
      },
      autoResize: {
        type: Boolean,
        default: true
      },
      queryConfig:{
          hotDataUrl:null,
          markerDataUrl:null,
          roadDataUrl:null
      },
      // 图标配置
      chartConfig: {
        type: Object,
        default: function() {
          return {
            markerIcon:null,
            markerIconHeight:30,
            markerIconWidth:30,
            dialogWidth:'500px',
            list:[],
            title:'',
            image:null,
            center: {
              lng: 116.404,
              lat: 39.915
            },
            zoom: 11
          }
        }
      }
    },
    computed: {
      widthHeight() {
        return {
          width: this.width,
          height: this.height
        }
      }
    },
    data() {
      return {
        chart: null,
        currentMarker:{scenicName:'',realCount:'',addCount:''},
        sidebarElm: null,
        hasInitMap: false,
        heatmapOverlay: null,
        chartConfigModel: {},
        map:null,
        hotMapData:[],
        realData:[],
        roadData:[],
        chartWidth: '100%',
        chartHeight: '100%',
        timer:null,
        defaultConfig: {
          list:[],
          title:'',
          image:null,
          center: {
            lng: 116.404,
            lat: 39.915
          },
          zoom: 11
        }

      }
    },
    watch: {
      // 防止表格预置数据不成功，涉及生命周期问题
      chartConfig: {
        handler(newValue, oldValue) {
          this.chartConfigModel = lodash.cloneDeep(newValue)
          let _config = lodash.cloneDeep(this.defaultConfig)
          lodash.merge(_config, this.chartConfigModel)
          this.chartConfigModel = _config
          this.initBaiduMap()
          //this.setHotMap()
          this.getData()
        },
        deep: true
      },
      widthHeight: {
        handler(newValue, oldValue) {
          this.initBaiduMap()
         this.getData()
        },
        deep: true
      }
    },
    created() {

    },
    mounted() {
      this.chartConfigModel = lodash.cloneDeep(this.chartConfig)
      let _config = lodash.cloneDeep(this.defaultConfig)
      lodash.merge(_config, this.chartConfigModel)
      this.chartConfigModel = _config
      this.initBaiduMap()
      this.getData()
      // this.timer=setInterval(function(){
      //   that.getData()
      // },1000*60*5)
      //this.setHotMap()
    },
    beforeDestroy() {
      if(this.timer!=null){
        clearInterval(this.timer)
        this.timer=null
      }
    },
    methods: {
      getData(){
          //this.map.clearOverlays()
        // if(this.queryConfig.hotDataUrl){
        //   getDataService(this.queryConfig.hotDataUrl,{}).then((res)=>{
        //     this.hotMapData=res
        //     this.setHotMap()
        //   })
        // }
       // if(this.queryConfig.markerDataUrl){
          this.setMarkerData()
       // }
        // if(this.queryConfig.roadDataUrl){
        //   this.getRoadData()
        // }
      },
      getRoadData(){
        let that=this
        getDataService(this.queryConfig.roadDataUrl,{}).then((res)=>{
          this.roadData=res
        })
      },
      setMarkerData(){
        let that=this
          if(this.chartConfig.list){
            for(let i=0;i<this.chartConfig.list.length;i++){
              let _config=this.chartConfig.list[i]
              var myIcon = new BMap.Icon(this.chartConfig.markerIcon, new BMap.Size(this.chartConfig.markerIconWidth, this.chartConfig.markerIconHeight),{imageSize:new BMap.Size(this.chartConfig.markerIconWidth, this.chartConfig.markerIconHeight)});
              // 创建Marker标注，使用小车图标
              var pt = new BMap.Point(_config.lng, _config.lat);
              var marker = new BMap.Marker(pt, {
                  icon: myIcon
              });
              let _c={
                title:_config.title,
                image:_config.image,
                list:_config.list
              }
              this.map.addOverlay(marker);
              marker.addEventListener('click', function () {
                  that.currentMarker=_c
                  that.$refs.markerDialog.show()
              });
          }
          }
      },
      initBaiduMap() {
        const _that = this
        this.map = new BMap.Map('baiduMap') // 创建Map实例
        this.map.centerAndZoom(new BMap.Point(this.chartConfigModel.center.lng, this.chartConfigModel.center.lat), this.chartConfigModel
          .zoom) // 创建点坐标,初始化地图,设置中心点坐标和地图级别
        this.map.addEventListener('zoomend', function(e) {
          var ZoomNum = _that.map.getZoom()
          console.info('===' + ZoomNum)
          //_that.setHotMap()
        })
        _that.hasInitMap = true
        if(this.chartConfigModel.mapStyle){
          this.map.setMapStyleV2({
            styleJson: this.chartConfigModel.mapStyle
          })
        }
        if (this.chartConfigModel.canMove) {
          this.map.enableScrollWheelZoom(); // 允许滚轮缩放
        }
        // let traffic = new BMap.TrafficLayer();
        // this.map.addTileLayer(traffic);
        // }
      },
      setHotMap() {
        if(this.hotMapData && this.hotMapData.length>0){
          this.heatmapOverlay = new BMapLib.HeatmapOverlay({
            'radius': 70
          })
          this.map.addOverlay(this.heatmapOverlay)
          this.heatmapOverlay.setDataSet({
            data: this.hotMapData,
            max: 70
          })
          this.setHotRadius()
          this.heatmapOverlay.show()
          this.setGradient()
        }

      },
      setHotRadius() {
        console.info('=======' + this.map.getZoom())
        if (this.heatmapOverlay != null && this.heatmapOverlay != undefined) {
          var zoomDiff = this.map.getZoom() - this.zoom
          if (zoomDiff > 0) {
            this.heatmapOverlay.setOptions({
              'radius': 100 * Math.pow(1.2, zoomDiff),
              'opacity': 0
            })
            this.setGradient();
          } else if (zoomDiff < 0) {
            this.heatmapOverlay.setOptions({
              'radius': 100 * Math.pow(0.5, Math.abs(zoomDiff)),
              'opacity': 0
            })
            this.setGradient();
          } else {
            this.heatmapOverlay.setOptions({
              'radius': 100 * Math.pow(0.5, Math.abs(zoomDiff)),
              'opacity': 0
            })
            this.setGradient();
          }
        }
      },
      setGradient() {
        var gradient = {
          0.1: '#88B1E5',
          0.3: '#5CE2E0',
          0.5: '#50E672',
          0.7: '#E5DF63',
          0.9: '#EA7B39',
          1: '#E92435'
        }
        this.heatmapOverlay.setOptions({
          'gradient': gradient
        })
      }
    }
  }
</script>
<style>
  .BMap_cpyCtrl {
      display:none;
    }
    .anchorBL{
        display:none;
    }
</style>

<style scoped="scoped">
  .input-card {
      top: 1rem;
      right: auto;

      max-height: 90%;
      display: flex;
      flex-direction: column;
      min-width: 0;
      word-wrap: break-word;
      background-color: #fff;
      background-clip: border-box;
      border-radius: .25rem;
      width: 22rem;
      border-width: 0;
      border-radius: 0.4rem;
      box-shadow: 0 2px 6px 0 rgba(114, 124, 245, .5);
      position: absolute;
      bottom: 1rem;
      right: 1rem;
      -ms-flex: 1 1 auto;
      flex: 1 1 auto;
      padding: 0.75rem 1.25rem;
  }
  .btn{
        margin-left: 0;
        font-size: 14px;
        margin-top: 20px;
        font-family: inherit;
        font-size: inherit;
        line-height: inherit;
        overflow: visible;
        text-transform: none
  }

  .btn {
      display: inline-block;
      font-weight: 400;
      text-align: center;
      margin-top: 20px;
      vertical-align: middle;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      border: 1px solid transparent;
      transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
      background-color: transparent;
      background-image: none;
      color: #25A5F7;
      border-color: #25A5F7;
      line-height: 1.5;
      border-radius: 1rem;
      -webkit-appearance: button;
      cursor: pointer;
  }
  .active{
      color: #fff;
      background-color: #25A5F7;
      border-color: #25A5F7
  }
  .btn:hover {
      color: #fff;
      background-color: #25A5F7;
      border-color: #25A5F7
  }

  .btn:hover {
      text-decoration: none
  }

  .btn:focus {
      outline: 0;
      box-shadow: none;
  }
</style>

<style >
  .customHotMap ::-webkit-scrollbar {
    width: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/map/CustomMapChart3.vue